import { apiClient } from '@features/shared/api/client'
import type {
  PreferenceAssignmentUpdate,
  PreferenceDefaultsResponse,
  UpdatePreferencesRequest,
} from './contracts'
import type { PreferenceDefaults, UpdatePreferenceDefaultsRequest } from '../models'

function toBackendPayload(payload: UpdatePreferenceDefaultsRequest): UpdatePreferencesRequest {
  const updates: PreferenceAssignmentUpdate[] = payload.updates.map((update) => ({
    preference_id: update.preference_id,
    assignee: {
      type: 'default',
      id: null,
    },
    value: update.value,
  }))

  return {
    updates,
    preferences: payload.preferences,
  }
}

export async function getPreferenceDefaults(): Promise<PreferenceDefaults> {
  const { data } = await apiClient.get<PreferenceDefaultsResponse>('/preferences')
  return data
}

export async function updatePreferenceDefaults(
  payload: UpdatePreferenceDefaultsRequest
): Promise<PreferenceDefaults> {
  const { data } = await apiClient.patch<PreferenceDefaultsResponse>(
    '/preferences',
    toBackendPayload(payload)
  )
  return data
}
